import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

export default class AppErrorBoundary extends React.Component {
  state = { hasError: false, errorKey: 0 };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[app] Критическая ошибка интерфейса:', error, info);
  }

  handleRetry = () => {
    this.setState((prev) => ({
      hasError: false,
      errorKey: prev.errorKey + 1,
    }));
  };

  render() {
    if (!this.state.hasError) {
      return (
        <React.Fragment key={this.state.errorKey}>
          {this.props.children}
        </React.Fragment>
      );
    }

    return (
      <Box
        component="main"
        sx={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          p: 2,
          background:
            'radial-gradient(circle at 50% 28%, rgba(52, 120, 246, 0.08), transparent 42%), var(--app-bg)',
        }}
      >
        <Paper
          elevation={0}
          className="card-pop"
          sx={{
            width: 'min(100%, 460px)',
            p: { xs: 3, sm: 4 },
            border: '1px solid var(--border-color)',
            borderRadius: 4,
            textAlign: 'center',
            background:
              'linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.96) 100%)',
            boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              mx: 'auto',
              mb: 2,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              background: 'rgba(52, 120, 246, 0.1)',
              color: '#3478f6',
            }}
          >
            <ErrorOutlineRoundedIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography variant="h5" fontWeight={750} gutterBottom sx={{ letterSpacing: '-0.02em' }}>
            Что-то пошло не так
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3, lineHeight: 1.55 }}>
            Интерфейс споткнулся. Можно попробовать ещё раз или вернуться на главную —
            ваши данные на сервере в порядке.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} justifyContent="center">
            <Button
              variant="contained"
              startIcon={<RefreshRoundedIcon />}
              onClick={this.handleRetry}
            >
              Попробовать снова
            </Button>
            <Button
              variant="outlined"
              startIcon={<HomeRoundedIcon />}
              onClick={() => window.location.assign('/home')}
            >
              На главную
            </Button>
          </Stack>
        </Paper>
      </Box>
    );
  }
}
